Application.Branding.Frame = {
    ui: {
        container: '.js-branding-frame',
        option: '.js-branding-frame__option',
        preview: '.js-branding-frame__preview'
    },
    ready: function () {

        var self = this;

        if (!$(this.ui.container).length){
            return;
        }

        // update preview position
        // bind on change
        $(this.ui.option).change(function(){
            self.update($(this).closest(self.ui.container));
        });
        // init
        $(this.ui.container).each(function(){
            self.update($(this));
        });

    },
    update: function($container){

        // find active frame
        var $active = $container.find(this.ui.option).filter(':checked');
        // apply to preview
        $(this.ui.preview).css({
            backgroundImage: 'url("' + $active.attr('data-frame') + '")'
        }).addClass('ready');

    }
};